<template>
  <div class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click="close"></button>
      <h2 class="layerTitle">카테고리 설정</h2>
      <div>
        <div class="mb15">
          <div class="innerTitle">
            <div class="checkbox">
              <input type="checkbox" id="item_activate" v-model="isActive">
              <label for="item_activate">{{ locale.activate }}</label>
            </div>
          </div>
        </div>
        <div class="mb15">
          <div class="innerTitle setLabel">{{locale.name}}</div>
          <SetLanguageValue
            :locale="locale"
            :langValue="categoryLabel" />
        </div>
        <div v-if="hasSubCategory" class="mb15">
          <div class="innerTitle setLabel">카테고리 메인 페이지 활성화</div>
          <p class="sysMessage">하위 카테고리가 있을 경우에만 적용 됩니다.</p>
          <span class="checkbox">
            <input type="checkbox" id="use_category_main" v-model="useMain" />
            <label for="use_category_main">{{ locale.activate }}</label>
          </span>
        </div>
        <div v-if="hasSubCategory && useMain" class="mb15">
          <div class="innerTitle setLabel">메인 페이지 타입</div>
          <p class="sysMessage">메인 이미지형: 해당 카테고리의 메인 이미지가 노출</p>
          <p class="sysMessage">배너형: 하위 카테고리들의 각 메인 이미지가 노출</p>
          <span class="checkbox">
            <input type="radio" name="category_mainpage_type" id="category_mainpage_type_image" value="image" v-model="mainType" />
            <label for="category_mainpage_type_image">메인 이미지형</label>
          </span>
          <span class="checkbox">
            <input type="radio" name="category_mainpage_type" id="category_mainpage_type_banner" value="banner" v-model="mainType" />
            <label for="category_mainpage_type_banner">배너형</label>
          </span>
        </div>
        <div v-if="(hasSubCategory && useMain && mainType === 'image') || isBannerItem">
          <div class="innerTitle setLabel">{{ isBannerItem ? '배너 이미지' : '메인 이미지'}}</div>
          <div v-if="mainImage" class="bgThumb">
            <img :src="mainImage" alt="">
            <button type="button" class="delThumb" @click="deleteImage('mainImage')"><img src="~@/assets/img/ico_close.svg" alt=""></button>
          </div>
          <div v-else>
            <input type="file" id="upload_category_mainpage_image" @change="uploadImage($event, 'mainImage')">
            <label for="upload_category_mainpage_image" class="btn toUppercase">{{locale.upload}}</label>
          </div>
        </div>
      </div>
      <div class="btns">
        <button type="button" class="btn btnWhite" @click="close">{{ locale.cancel }}</button>
        <button type="button" class="btn btnPrimary" :disabled="isDisabled" @click="apply">{{ locale.apply }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import LANG from '@/common/lang'
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import SetLanguageValue from '@/components/Util/SetLanguageValue'

export default {
  name: 'CollectionCategoryDetail',
  props: [
    'locale',
    'categoryId',
    'categoryData'
  ],
  components: {
    SetLanguageValue
  },
  computed: {
    isLastSub: {
      get () {
        return !(this.subCategory?.length)
      },
      set (isLastSub) {
        if (isLastSub) {
          this.useMain = false
        }
      }
    },
    isDisabled () {
      const useMain = this.useMain
      const imageType = this.mainType === 'image'
      const hasImage = this.mainImage
      return useMain && imageType && !hasImage
    },
    isBannerItem () {
      return this.categoryData?.isBannerItem
    }
  },
  created () {
    Object.assign(this, {
      isActive: this.categoryData.isActive ?? true,
      categoryLabel: this.categoryData.categoryLabel || LANG.valueObj(''),
      useMain: this.categoryData.useMain ?? true,
      mainType: this.categoryData.mainType || 'image',
      mainImage: this.categoryData.mainImage || '',
      hasSubCategory: this.categoryData.hasSubCategory ?? true
    })
  },
  data () {
    return {
      categoryLabel: LANG.valueObj(''),
      isActive: true,
      useMain: true,
      mainType: 'image',
      mainImage: '',
      hasSubCategory: true
    }
  },
  methods: {
    uploadImage (e, target) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const isImage = regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())
      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          this[target] = res.source
          e.target.value = ''
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    deleteImage (target) {
      if (window.confirm(this.locale.confirm_delete)) {
        this[target] = ''
      }
    },
    apply () {
      if (window.confirm(this.locale.confirm_apply)) {
        const data = {
          isActive: this.isActive,
          categoryLabel: this.categoryLabel,
          useMain: this.useMain,
          mainType: this.mainType,
          mainImage: this.mainImage
        }
        this.$emit('apply', { categoryId: this.categoryId, info: data })
        this.$emit('close')
      }
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .inner {
    max-width: 400px;
  }
}
</style>
